export default "__VITE_ASSET__BbgQgT0K__"